import { Component, OnInit } from '@angular/core';
import { AuthenticationService, QuotationCartService } from '@app/_services';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ConfirmDialogComponent } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { Router, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.sass'],
    standalone: true,
    imports: [NgFor, RouterLinkActive, NgIf, RouterLink, RouterOutlet]
})
export class LayoutComponent implements OnInit {
    links: any = [
        ...(this.quotationCartService.quantity > 0 ? [{ label: 'Quotation Requests', url: './requests' }] : []),
        { label: 'Active Quotations', url: './active' },
        { label: 'Quotation History', url: './history' },
    ];
    bsModalRef: BsModalRef;
    userDetails;
    constructor(private authService: AuthenticationService,
        private quotationCartService: QuotationCartService,
        public router: Router,
        private modalService: BsModalService) { }

    ngOnInit() {

    }


    logout() {
        this.bsModalRef = this.modalService.show(ConfirmDialogComponent, { class: 'modal-sm' });
        this.bsModalRef.content.onClose.subscribe((confirmed) => {
            if (confirmed) {
                this.authService.logout().subscribe(res=>{
                    res
                });
                this.router.navigate(['/'])
            }
        });

    }


}
